toggleSidebar = function(){
	if ($('.sidebar').hasClass('fliph')) {
        $('#sidebar-collapse > i').attr('class', 'fa fa-angle-double-right');
    } else {
        $('#sidebar-collapse > i').attr('class', 'fa fa-angle-double-left');
    }
}

// Delegated from document rather than bound to #sidebar-collapse directly.
//
// #sidebar-collapse is rendered by Angular (sidebar.component.html), and this file runs from
// the global scripts bundle before Angular has bootstrapped. A direct
// $('#sidebar-collapse').click(...) inside document.ready usually found no element yet, so no
// handler was attached and the arrow did nothing. A delegated handler matches the element
// whenever it exists, including if Angular re-renders it.
$(document).on('click', '#sidebar-collapse', function(){
	$('.sidebar').toggleClass('fliph');
	toggleSidebar();
});
